import React from "react";

const Footer = () => {
  return (
    <footer className="layout-container py-12 border-t border-borderSubtle/30 flex flex-col sm:flex-row justify-end items-center gap-4 text-xs font-mono text-zinc-600 select-none">
      <span>
        &copy; {new Date().getFullYear()} Rupak Boral. All rights reserved.
      </span>
    </footer>
  );
};

export default Footer;
